import React from 'react'

import {
    Button,
    Card,
    CardContent,
    Grid,
    Modal,
    TextField,
    Typography,
    Box,
    CardHeader
} from '@material-ui/core'
import MenuItem from '@material-ui/core/MenuItem';

// Custom Hooks
import {useForm} from '../hooks/useForm';
import { commonModuleStyles } from '../../../../assets/styles/jss/pages/common/CommonModuleStyles';

const initState = {type: '', value: ''}
const NewItem = ({openModal, handleClose, stateUser, name, label, title, handleSubmit}) => {

    const [data, setData] = React.useState(initState);
    const [errors, setErrors] = React.useState({});
    const [loading, setLoading] = React.useState(false);
    const [loadMessage, setLoadMessage] = React.useState("");
    const [toastProps, setToastProps] = React.useState({
        message: "",
        open: false
    });

    const classes = commonModuleStyles();

    const handleCancelar = () => {
        handleClose();
        setData(initState);
    }

    const handleInputChange = ({target: {value}}) => setData({type: name, value})

    return (
        <Modal
            open={openModal}
            onClose={handleCancelar}
            className={classes.modal}
            BackdropProps={{
                style: {
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                }
            }}
        >
            <Card className={classes.modalCard}>
                <CardHeader
                    title={<Typography variant="h6" className={classes.title}>Nuev{title}</Typography>}
                />
                <CardContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                required
                                margin="dense"
                                variant="outlined"
                                label={label}
                                fullWidth
                                name={name}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onChange={handleInputChange}
                                // error={Boolean(errors[label])}
                                // helperText={errors[label]}
                            />
                        </Grid>
                    </Grid>

                    <Box className={classes.buttonsContainer}>
                        <Button variant='outlined' onClick={handleCancelar} className={classes.cancelButton}>
                            Cancelar
                        </Button>
                        <Button color="primary" onClick={() => handleSubmit(data)} variant="contained">
                            Guardar
                        </Button>
                    </Box>


                </CardContent>
            </Card>
        </Modal>
    )
}

export default NewItem
